// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure the popup has proper positioning and high z-index */
.custom-calendar-popup.p-datepicker {
    position: absolute !important;
    transform: translate(90%, 10%) !important; /* Left & Top */
    z-index: 99999 !important;
    margin-top: -8px; /* optional tweak */
    margin-left: -8px; /* optional tweak */
  }

  @media (max-width: 768px) {
    .custom-calendar-popup.p-datepicker {
      transform: translate(0%, 0%) !important; /* Adjust for smaller screen */
      left: 0 !important;
      right: 0 !important;
      margin: 0 auto !important;
      width: 90vw !important; /* Responsive width */
      max-width: 360px; /* Optional: constrain max width */
    }
  }
  
  /* Optional: fine-tune arrow position if needed */
  .custom-calendar-popup.p-datepicker::before {
    left: auto;
    right: 10px; /* adjust as needed */
  }
  .edit_calender{
    position: relative;
    display: inline-block;
    margin-right: -5px;
  }
  `, "",{"version":3,"sources":["webpack://./src/Modules/Reusuablecomponents/EditCalendar/editCalendar.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;IACI,6BAA6B;IAC7B,yCAAyC,EAAE,eAAe;IAC1D,yBAAyB;IACzB,gBAAgB,EAAE,mBAAmB;IACrC,iBAAiB,EAAE,mBAAmB;EACxC;;EAEA;IACE;MACE,uCAAuC,EAAE,8BAA8B;MACvE,kBAAkB;MAClB,mBAAmB;MACnB,yBAAyB;MACzB,sBAAsB,EAAE,qBAAqB;MAC7C,gBAAgB,EAAE,kCAAkC;IACtD;EACF;;EAEA,iDAAiD;EACjD;IACE,UAAU;IACV,WAAW,EAAE,qBAAqB;EACpC;EACA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;EACpB","sourcesContent":["/* Ensure the popup has proper positioning and high z-index */\r\n.custom-calendar-popup.p-datepicker {\r\n    position: absolute !important;\r\n    transform: translate(90%, 10%) !important; /* Left & Top */\r\n    z-index: 99999 !important;\r\n    margin-top: -8px; /* optional tweak */\r\n    margin-left: -8px; /* optional tweak */\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    .custom-calendar-popup.p-datepicker {\r\n      transform: translate(0%, 0%) !important; /* Adjust for smaller screen */\r\n      left: 0 !important;\r\n      right: 0 !important;\r\n      margin: 0 auto !important;\r\n      width: 90vw !important; /* Responsive width */\r\n      max-width: 360px; /* Optional: constrain max width */\r\n    }\r\n  }\r\n  \r\n  /* Optional: fine-tune arrow position if needed */\r\n  .custom-calendar-popup.p-datepicker::before {\r\n    left: auto;\r\n    right: 10px; /* adjust as needed */\r\n  }\r\n  .edit_calender{\r\n    position: relative;\r\n    display: inline-block;\r\n    margin-right: -5px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
